<template>
  <div class="submit-worksheet-container">
    <div class="jc-page-header">
      <div class="jc-page-header">
        <h1>
          <i class="jc-icon-my-circle-bold"></i>{{$t('ticket.submissionWork')}}
        </h1>
        <div class="jc-box-action">
          <a v-bind:href="Config.WORKSHEET_SERVER_URL"
             target="_blank">{{$t('ticket.helpDoc',[$t('ticket.submissionWork')])}}</a>
        </div>
      </div>
    </div>
    <div class="jc-page-content">
      <div class="submit-option"
           v-for="group in wrappedTicketTypes"
           :key="group.ticketTypeName">
        <!--<el-row>-->
        <!--<el-col :span="24">-->
        <!--<div class="worksheet-type-text">{{$t('ticket.workType')}}</div>-->
        <!--<br>-->
        <!--</el-col>-->
        <!--</el-row>-->
        <!--<el-row>-->
        <!--<el-col :span="8" v-for="item in ticketTypeList" :key="item.ticketTypeId">-->
        <!--<div :class="classMap[item.status]"
        class="grid-content worksheet-box"
        @click="junpToCabinetOutfit(item.ticketTypeId)">-->
        <!--<div class="worksheet-pic">-->
        <!--<img src="../../../static/img/first.svg" alt="">-->
        <!--</div>-->
        <!--<div class="worksheet-content">-->
        <!--<p class="worksheet-box-title">{{item.ticketTypeName}}</p>-->
        <!--<p class="worksheet-box-dec">{{item.desc}}</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</el-col>-->
        <!--<el-col :span="8" v-for="item in ticketTypeListDis" :key="item.ticketTypeId">-->
        <!--<div class="grid-content worksheet-box worksheet-box-unable">-->
        <!--<div class="worksheet-pic">-->
        <!--<img src="../../../static/img/second.svg" alt="">-->
        <!--</div>-->
        <!--<div class="worksheet-content">-->
        <!--<p class="worksheet-box-title">{{item.ticketTypeName}}</p>-->
        <!--<p class="worksheet-box-dec">{{item.ticketDes}}</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</el-col>-->
        <!--</el-row>-->
        <el-row>
          <el-col :span="24">
            <div class="worksheet-type-text detail-module-title">{{ group.ticketTypeName }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8"
                  v-for="item in group.ticketTemplates"
                  :key="item.ticketTemplateName">
            <!--每种工单-->
            <div class="grid-content worksheet-box worksheet-box-able"
                 @click="onTicketClick(item)">
              <div class="worksheet-pic">
                <img :src="item.icon"
                     :alt="item.ticketTemplateName">
              </div>
              <div class="worksheet-content ">
                <p class="worksheet-box-title">{{ item.ticketTemplateName }}</p>
                <p class="worksheet-box-dec">{{ item.desc }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

// import CabinetOutfit from '@/components/workSheet/CabinetOutfit';

// 工单模板CODE
const TICKET_TEMPLATE_CABINETINITIAL = 'CabinetInitial'; // 机柜初装
const TICKET_TEMPLATE_RESOURCE_RESVER = 'ResourceReservation'; // 资源预留
// const TICKET_TEMPLATE_VISIT_APPLICATION = 'VisitApplication'; // 人员入室
const TICKET_TEMPLATE_VISIT_APPLICATION = 'VisitApplicationV2'; // 人员入室

// const TICKET_TEMPLATE_DEVICE_MOVE = 'DeviceMove'; // 设备异动
const TICKET_TEMPLATE_DEVICE_MOVE = 'DeviceMoveV2'; // 设备异动
// const TICKET_TEMPLATE_DEVICE_MOVEIN = 'DeviceMoveIn'; // 设备迁入
const TICKET_TEMPLATE_DEVICE_MOVEIN = 'DeviceMoveInV2'; // 设备迁入
// const TICKET_TEMPLATE_DEVICE_MOVEOUT = 'DeviceMoveOut'; // 设备迁出
const TICKET_TEMPLATE_DEVICE_MOVEOUT = 'DeviceMoveOutV2'; // 设备迁出
const TICKET_TEMPLATE_DEVICE_REBOOT = 'DeviceReboot'; // 设备重启
const TICKET_TEMPLATE_SYSTEM_REINSTAL = 'SystemReinstall'; // 系统重装
const TICKET_TEMPLATE_RESET_BMC = 'ResetBMC'; // 重置BMC
const TICKET_TEMPLATE_DEVICE_VIEW = 'DeviceView'; // 设备查看
const TICKET_TEMPLATE_NETWORK_MAINT = 'NetworkMaint'; // 网线维护
const TICKET_TEMPLATE_DEVICE_BOOT = 'DeviceBoot'; // 设备开机
const TICKET_TEMPLATE_DEVICE_SHUT_DOWN = 'DeviceShutDown'; // 设备关机
const TICKET_TEMPLATE_PERIPHERAL_ACCESS = 'PeripheralAccess'; // 外设接入
const TICKET_TEMPLATE_IP_CONFIG = 'IPConfig'; // IP地址配置
const TICKET_TEMPLATE_REMOTE_CONNECTION = 'RemoteConnection'; // 远程连接配置
const TICKET_TEMPLATE_OTHER_SERVICE = 'OtherService'; // 其他服务
const TICKET_TEMPLATE_HARD_DISK_FAULT = 'HardDiskFault'; // 硬盘故障
const TICKET_TEMPLATE_POWER_FAULT = 'PowerFault'; // 电源故障
const TICKET_TEMPLATE_CABLE_FAULT = 'CableFault'; // 网线故障
const TICKET_TEMPLATE_OTHER_FAULT = 'OtherFault'; // 其他故障
const TICKET_TEMPLATE_COLLECT_DELIVERY = 'CollectDelivery'; // 代收快递
const TICKET_TEMPLATE_SEND_DELIVERY = 'SendDelivery'; // 代收快递

// 新增5类服务支持工单
const TICKET_TEMPLATE_NET_OFF = 'DeviceNetoff'; // 设备断网
const TICKET_TEMPLATE_POWER_OFF = 'DevicePoweroff'; // 设备断电
const TICKET_TEMPLATE_REPLACE_CHANGE = 'ReplacementChange'; // 设备外置配件更换
const TICKET_TEMPLATE_CABINET_VIEW = 'CabinetView'; // 机柜查看
const TICKET_TEMPLATE_VERIFY_DISTANCE = 'VerifyWiringDistance'; // 核实布线距离

const TICKET_TEMPLATE_CABINRT_POWERUP = 'CabinetElectrified'; // 机柜加电
const TICKET_TEMPLATE_CABINRT_RESERVE = 'CabinetReservation'; // 机柜预留
const TICKET_TEMPLATE_CABINRT_POWEROFF = 'CabinetPowerOff'; // 机柜关电
const TICKET_TEMPLATE_EQUIPMENT_UNSUBSCRIBE = 'DeviceUnsubscribe'; // 设备退定
const TICKET_TEMPLATE_DEVICE_OPEN = 'DeviceOpen'; // 设备开通

const TICKET_TEMPLATE_GENERA_SERVER = 'GeneralServices'; // 通用服务

const classMap = {
  0: 'worksheet-box-unable',
  1: 'worksheet-box-able'
};
export default {
  components: {},
  name: 'SubmitWorkSheet',
  data () {
    return {
      ticketTypeList: [],
      classMap,
      ticketTypeListDis: [],
      ticketTypes: []
    };
  },
  created () {
    this.getTicketType();
  },
  mounted () { },
  watch: {},
  computed: {
    wrappedTicketTypes () {
      return this.ticketTypes.map((group) => {
        group.ticketTemplates.forEach((item) => {
          item.icon = this.getIcon(item);
          item.route = this.getRoute(item);
        });
        return group;
      });
    }
  }, // end of computed
  methods: {
    junpToCabinetOutfit (ticketTypeId) {
      this.$router.push({
        path: `/worksheet/submit/${ticketTypeId}`,
        query: { ticketTypeId }
      });
    },
    // 查询工单类型
    getTicketType () {
      this.$api.getTicketType({ idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        const { ticketTypes } = res.data;
        this.ticketTypes = ticketTypes;
      }).catch((error) => {
        this.$message({
          showClose: true,
          message: error.errmsg,
          type: 'error'
        });
      });
    },
    getIcon (item) {
      return `../../../../static/img/worksheet/${item.ticketTemplateCode}.svg`;
    },
    /**
     * 取得创建具体类型工单的路由
     * @param {Object} item - 工单数据
     */
    getRoute (item) {
      let route = null;
      const { ticketTemplateCode, ticketTemplateId, ticketTypeId } = item;
      switch (ticketTemplateCode) {
        case TICKET_TEMPLATE_CABINETINITIAL:
          route = `/worksheet/submit/${ticketTypeId}`;
          break;
        case TICKET_TEMPLATE_RESOURCE_RESVER:
          route = `/resourcebid/${ticketTemplateId}`;
          break;
        // 服务支持类工单
        case TICKET_TEMPLATE_DEVICE_REBOOT:
        case TICKET_TEMPLATE_SYSTEM_REINSTAL:
        case TICKET_TEMPLATE_RESET_BMC:
        case TICKET_TEMPLATE_DEVICE_VIEW:
        case TICKET_TEMPLATE_NETWORK_MAINT:
        case TICKET_TEMPLATE_DEVICE_BOOT:
        case TICKET_TEMPLATE_DEVICE_SHUT_DOWN:
        case TICKET_TEMPLATE_PERIPHERAL_ACCESS:
        case TICKET_TEMPLATE_IP_CONFIG:
        case TICKET_TEMPLATE_REMOTE_CONNECTION:
        case TICKET_TEMPLATE_OTHER_SERVICE:
        case TICKET_TEMPLATE_NET_OFF:
        case TICKET_TEMPLATE_POWER_OFF:
        case TICKET_TEMPLATE_REPLACE_CHANGE:
        case TICKET_TEMPLATE_CABINET_VIEW:
        case TICKET_TEMPLATE_VERIFY_DISTANCE:
          route = `/worksheet/submit/servicesupport/${ticketTypeId}/${ticketTemplateId}`;
          break;
        case TICKET_TEMPLATE_VISIT_APPLICATION:
          route = `/worksheet/submit/roomEntry/${ticketTemplateId}`;
          break;
        // 设备迁入
        case TICKET_TEMPLATE_DEVICE_MOVEIN:
          route = `/worksheet/submit/equipmentMoveIn/${ticketTemplateId}/${ticketTypeId}`;
          break;
        // 设备迁出
        case TICKET_TEMPLATE_DEVICE_MOVEOUT:
          route = `/worksheet/submit/equipmentMoveOut/${ticketTemplateId}/${ticketTypeId}`;
          break;
        // 设备异动
        case TICKET_TEMPLATE_DEVICE_MOVE:
          route = `/worksheet/submit/equipmentMove/${ticketTemplateId}/${ticketTypeId}`;
          break;
        // 故障提报
        case TICKET_TEMPLATE_HARD_DISK_FAULT: case TICKET_TEMPLATE_POWER_FAULT:
        case TICKET_TEMPLATE_CABLE_FAULT: case TICKET_TEMPLATE_OTHER_FAULT:
          route = `/worksheet/submit/faultReport/${ticketTemplateId}/${ticketTypeId}`;
          break;
        // 收发快递
        case TICKET_TEMPLATE_COLLECT_DELIVERY:
          route = `/worksheet/submit/collectDelivery/${ticketTemplateId}/${ticketTypeId}`;
          break;
        case TICKET_TEMPLATE_SEND_DELIVERY:
          route = `/worksheet/submit/SendDelivery/${ticketTemplateId}/${ticketTypeId}`;
          break;
        // 机柜加电
        case TICKET_TEMPLATE_CABINRT_POWERUP:
          route = `/worksheet/submit/cabinetPowerUp/${ticketTypeId}/${ticketTemplateId}`;
          break;
        // 机柜预留
        case TICKET_TEMPLATE_CABINRT_RESERVE:
          route = `/worksheet/submit/cabinetReservation/${ticketTypeId}/${ticketTemplateId}`;
          break;
        // 机柜关电
        case TICKET_TEMPLATE_CABINRT_POWEROFF:
          route = `/worksheet/submit/cabinetPowerOff/${ticketTypeId}/${ticketTemplateId}`;
          break;
        case TICKET_TEMPLATE_EQUIPMENT_UNSUBSCRIBE:
          route = `/worksheet/submit/equipmentUnsubscribe/${ticketTypeId}/${ticketTemplateId}`;
          break;
        case TICKET_TEMPLATE_DEVICE_OPEN:
          route = `/worksheet/submit/deviceOpen/${ticketTypeId}/${ticketTemplateId}`;
          break;

        // 通用服务
        case TICKET_TEMPLATE_GENERA_SERVER:
          route = `/generalServer/${ticketTypeId}/${ticketTemplateId}`;
          break;
        default:
          break;
      }
      return route;
    },
    onTicketClick (item) {
      this.$router.push(item.route);
    }
  }
};
</script>
<style lang="scss">
@import "./scss/SubmitWorkSheet";
.submit-worksheet-container .worksheet-box {
  margin-left: 5px !important;
}

.submit-worksheet-container .worksheet-type-text {
  font-weight: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/SubmitWorkSheet.vue